import React from 'react'
import styled from 'styled-components'
import {mediaQueries} from '../shared/config'
export default function LargeSubheader(props) {
    return (
        <Subheader id={props.id}>
           {props.title} 
        </Subheader>
    )
}

const Subheader = styled.h1`
    font-family: 'Merienda', cursive;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    font-size: 60px;
    color: #D9A648;
    text-shadow: 0px 4px 13px rgba(56, 28, 28, 0.18);
    margin-top: 0;
    padding-top: 80px;
    ${mediaQueries.mobile} {
		padding: 20px 0 20px 0;
        font-size: 30px;
	}
    margin-bottom: 0;
`    